/* eslint-disable import/extensions */
import React from 'react'
import type {
    GroupByType,
    SwingTimingData,
} from 'leaderboard/scripts/swing-path/types/globals.ts'
import type { GroupByLogic } from './utils/do-group-by-logic.ts'
import LeagueAverageLegendItem from './LeagueAverageLegendItem.tsx'
import PlayerCardChart from './PlayerCardChart.tsx'
import type { PitchTypeColorMode } from './utils/can-use-pitch-type-colors.ts'
import type SwingTimingChart from './swing-timing-chart.ts'
import { MAX_SWING_TIMING_SELECTIONS } from './utils/constants.ts'

type LegendProps = {
    rows: SwingTimingData[]
    handleClick: (row: SwingTimingData) => void
    groupByLogic: GroupByLogic
    type: GroupByType
    groupBys: string[]
    showLeagueAverages: boolean
    pitchTypeColors: boolean
    pitchTypeColorMode: PitchTypeColorMode
    hoveredKey: string | null
    charts: SwingTimingChart[]
    loadingUniqueIds: Set<string>
}

export default function Legend(props: LegendProps) {
    const {
        handleClick,
        rows,
        groupByLogic,
        type,
        groupBys,
        showLeagueAverages,
        pitchTypeColors,
        pitchTypeColorMode,
        hoveredKey,
        charts,
        loadingUniqueIds,
    } = props

    const isEmpty = rows.length === 0
    const isFull = rows.length >= MAX_SWING_TIMING_SELECTIONS

    const emptyClass = isEmpty ? 'swing-timing-legend-empty' : ''

    return (
        <div className={`swing-timing-legend ${emptyClass}`}>
            {rows.map((row) => (
                <div
                    key={row.uniqueId}
                    className={
                        hoveredKey === row.uniqueId
                            ? 'swing-timing-legend-card-hovered'
                            : ''
                    }
                >
                    <PlayerCardChart
                        row={row}
                        groupByLogic={groupByLogic}
                        handleSelect={() => handleClick(row)}
                        type={type}
                        pitchTypeColors={pitchTypeColors}
                        pitchTypeColorMode={pitchTypeColorMode}
                        charts={charts}
                        isLoading={loadingUniqueIds.has(row.uniqueId)}
                    />
                    {showLeagueAverages && (
                        <LeagueAverageLegendItem
                            uniqueId={row.uniqueId}
                            groupBys={groupBys}
                            pitchTypeColors={pitchTypeColors}
                            pitchTypeColorMode={pitchTypeColorMode}
                            implicitPitchHand={row.pitch_hand_type}
                            implicitBatSide={row.bat_side_type}
                        />
                    )}
                </div>
            ))}
            {!isFull && !isEmpty && (
                <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                    <button
                        type="button"
                        className="swing-timing-legend-add-button"
                        popovertarget="player-search"
                        aria-label="Add player"
                    >
                        <span>+</span>
                    </button>
                </div>
            )}
            {isEmpty && (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <button
                        type="button"
                        popovertarget="player-search"
                        aria-label="Add player"
                        className="btn btn-default"
                    >
                        Click here to add a player!
                    </button>
                </div>
            )}
        </div>
    )
}
